// src/firebase/init.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCKLCICEoM76OPMvP6ojWczGgr76iKPNBE",
  authDomain: "sbleducationalportal.firebaseapp.com",
  projectId: "sbleducationalportal",
  storageBucket: "sbleducationalportal.firebasestorage.app",
  messagingSenderId: "341887740482",
  appId: "1:341887740482:web:e39a04a8b836e1c3cd1bdb",
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// DEBUG: expose for browser console
if (typeof window !== "undefined") {
  window._auth = auth;
  window._storage = storage;
  window.__FIREBASE_BUCKET__ = app.options.storageBucket; // ✅ will print the bucket string
}
